import React from 'react';

const ReferralContext = React.createContext({
  referralInfo: {},
  affiliateInfo: {},
  invalidReferral: false,
});

export default ReferralContext;
